import React from 'react'

import { CommonModalTitlePartsProps, CommonModalTitleProps } from '../../types'

export const ModalTitle = (props: CommonModalTitleProps): React.ReactNode => {
  if (props.title && typeof props.title === 'string') {
    return <>{props.title}</>
  }

  if (isModalTitleParts(props)) {
    return (
      <>
        {props.title?.start && <span>{props.title?.start} </span>}
        {props.title?.text}
        {props.title?.end && <span> {props.title?.end}</span>}
      </>
    )
  }

  if (props.title) {
    return <>{props.title}</>
  }

  return null
}

const isModalTitleParts = (props: CommonModalTitleProps): props is CommonModalTitlePartsProps => {
  const { title } = props

  const isTitlePart =
    title && typeof title !== 'string' && title.text && typeof title.text === 'string'
  const isTitleStart = isTitlePart && 'start' in title
  const isTitleEnd = isTitlePart && 'end' in title

  return ((isTitlePart && isTitleStart) || (isTitlePart && isTitleEnd)) as boolean
}
